import chatgptLogo from '@/assets/llm-logos/chatgpt.png';
import claudeLogo from '@/assets/llm-logos/claude.png';
import geminiLogo from '@/assets/llm-logos/gemini.png';
import perplexityLogo from '@/assets/llm-logos/perplexity.png';
import grokLogo from '@/assets/llm-logos/grok.png';

const logos = [
  { src: chatgptLogo, alt: 'ChatGPT' },
  { src: claudeLogo, alt: 'Claude' },
  { src: geminiLogo, alt: 'Gemini' },
  { src: perplexityLogo, alt: 'Perplexity' },
  { src: grokLogo, alt: 'Grok' },
];

interface FinalCtaProps {
  onRequestAccess: () => void;
}

export default function FinalCta({ onRequestAccess }: FinalCtaProps) {
  return (
    <section className="flex flex-col items-center w-full px-4 md:px-0">
      <div className="flex flex-col items-center max-w-[800px]">
        {/* Avatar row */}
        <div className="flex items-center justify-center pr-3">
          {logos.map((logo) => (
            <div
              key={logo.alt}
              className="bg-white border-2 border-[rgba(2,2,3,0.06)] rounded-full w-12 h-12 -mr-3 overflow-hidden flex items-center justify-center"
            >
              <img
                src={logo.src}
                alt={logo.alt}
                className="w-8 h-8 object-cover"
              />
            </div>
          ))}
        </div>

        {/* Headline + Subtitle */}
        <div className="flex flex-col items-center gap-3 mt-[23px]">
          <h2 className="font-headline text-[32px] md:text-[40px] leading-[1.2] text-[#1e1c1c] text-center max-w-[640px]">
            A year from now, you'll either show up in AI answers or wonder where
            your traffic went.
          </h2>
          <p className="font-body font-medium text-[16px] text-[#1e1c1c] opacity-70 leading-[1.5]">
            Show up in both, or watch traffic disappear.
          </p>
        </div>

        {/* CTA + Urgency */}
        <div className="flex flex-col items-center gap-5 mt-8">
          <button
            onClick={onRequestAccess}
            className="bg-primary rounded text-white p-4 font-body font-semibold text-[16px]"
          >
            Book Free AI Visibility Review
          </button>
          <span className="font-body font-semibold text-[12px] tracking-[0.6px] uppercase text-[#1e1c1c] opacity-70">
            15 minutes. No obligation.
          </span>
        </div>
      </div>
    </section>
  );
}
